<template>
    <div>
      <!-- modal -->
      <b-modal id="serviceFeeFormModal" ref="serviceFeeFormModal" centered size="md" no-close-on-backdrop  :title=" $t('serviceFee.info')" :cancel-title=" $t('others.cancel_title')"
        :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate">
        <b-row>
            <b-col> 
                <label for="service-fee-price-input">{{ $t('serviceFee.price') }}</label>
                <b-form-group>
                    <b-form-input id="service-fee-price-input" type="number" size="sm" v-model="price" maxlength="50"/>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col> 
                <label for="service-fee-online-price-input">{{ $t('serviceFee.online_price') }}</label>
                <b-form-group>
                    <b-form-input id="service-fee-online-price-input" type="number" size="sm" v-model="onlinePrice" maxlength="50"/>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col> 
                <label for="service-fee-fees-input">{{ $t('serviceFee.fees') }}</label>
                <b-form-group>
                    <b-form-input id="service-fee-fees-input" type="number" size="sm" v-model="officialFee" maxlength="50"/>
                </b-form-group>
            </b-col>
        </b-row>
      </b-modal>
    </div>
  </template>
  <script>
  export default {
    props: {
        getServiceFeeList: {type: Function},
    },
    data() {
      return {
        id: 0,
        price: 0,
        onlinePrice: 0,
        officialFee: 0
      }
    },
    methods: {
      showInfo(id) {  
        this.$refs['serviceFeeFormModal'].show()
        this.id = id
        const data = {id: this.id}
        const controller = {name : 'ServiceFee'}
        const payload = {data: data, controller: controller}
        this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
            if(response.data.resultStatus == true){
                this.price = response.data.serviceFee.price
                this.onlinePrice = response.data.serviceFee.onlinePrice
                this.officialFee = response.data.serviceFee.officialFee
                this.paymentTypeId = response.data.serviceFee.paymentTypeId
            } else {
                this.$bvModal.hide('serviceFeeFormModal')
                this.$WarningAlert(response.data.resultMessage)
            }  
        })  
      },
      addOrUpdate() {
        const data = {id: this.id, price: this.price, onlinePrice: this.onlinePrice, officialFee: this.officialFee  }
        const controller = {name : 'ServiceFee'}
        const payload = {data: data, controller: controller}
        this.$store.dispatch('moduleAuth/save',payload).then((response) => {
            if(response.data.resultStatus == true){
                this.$bvModal.hide('serviceFeeFormModal')
                this.getServiceFeeList()
                this.$SaveAlert()
            } else {
                this.$WarningAlert(response.data.resultMessage)
            }
        })
      }
    }
  }
  </script>
  <style lang="scss">
  [dir=ltr] .modal-header .close {
      margin: -0.4rem -0.4rem -0.8rem auto;
  }
  [dir] label {
      margin-bottom: 0.2857rem;
      font-weight: bold;
  }
  .modal .modal-content {
      overflow: visible;
      margin-bottom: auto;
  }
  [dir] .invalid-tooltip {
      padding: 0.4rem 0.775rem!important;
      margin-top: -1.5rem!important;
      background-color: #ea5455!important;
      border-radius: 0.358rem!important;
      left: 20px!important
  }
  </style>
  